module.exports = __webpack_public_path__ + "media/images/icon__close--rb-dark-gray@3x-43e1835d0e9148b91f31efb046d5d431.png";